import { render } from "./CalculatorStandart.vue?vue&type=template&id=5d283a7e&scoped=true&ts=true"
import script from "./CalculatorStandart.vue?vue&type=script&lang=ts"
export * from "./CalculatorStandart.vue?vue&type=script&lang=ts"

import "./CalculatorStandart.vue?vue&type=style&index=0&id=5d283a7e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d283a7e"]])

export default __exports__